

















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import Thumbnail from '@/components/Thumbnail.vue'

import '@/global-types.ts'

@Component({
  components: {
    Thumbnail,
  }
})
export default class DocumentsList extends Vue {
  @Prop() docs!: tdDocMeta[];
  @Prop() list!: boolean;
  @Prop() loading!: boolean;

  downloading: { [id: string]: boolean } = {}

  download (identifier: string) {
    Vue.set(this.downloading, identifier, true)
    const url = ((this.$store.getters.server.url.startsWith('https://') || this.$store.getters.server.url.startsWith('http://')) ? this.$store.getters.server.url : 'https://' + this.$store.getters.server.url) + '/doc/' + identifier
    const options = {
      headers: {
        Authorization: this.$store.getters.server.server.headers.get('Authorization')
      }
    }

    fetch(url, options)
      .then(r => r.blob())
      .then(b => {
        Vue.set(this.downloading, identifier, false)
        const link = document.createElement('a')
        link.href = URL.createObjectURL(b)
        link.download = this.docs.find(d => d.identifier === identifier)?.title || identifier
        link.click();
      })
  }
}
